import { CloseIcon } from "@assets/icons";
import { Button } from "@altimateai/lego";
import classes from "./styles.module.scss";
import { useEffect, useState } from "react";
import { useAppDispatch } from "@/modules/app/useAppContext";
import { setHasAcceptedCookies } from "@/modules/app/appSlice";
import { COOKIE_CONSENT_ATTR } from "@/lib/dom-attrs";
import { hasAcceptedCookies, StorageKeyName } from "./utils";
import { Stack } from "@altimateai/lego";

const CookieConsentBanner = () => {
  const [isClosed, setIsClosed] = useState(false);
  const hasActedOnCookieConsent = localStorage.getItem(StorageKeyName) !== null;
  const acceptedCookies = hasAcceptedCookies();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setHasAcceptedCookies(acceptedCookies));
  }, [acceptedCookies, dispatch]);

  const acceptCookies = () => {
    localStorage.setItem(StorageKeyName, "true");
    handleClose();
  };

  const handleClose = () => {
    setIsClosed(true);
  };

  if (isClosed || hasActedOnCookieConsent) {
    return null;
  }

  return (
    // ``COOKIE_CONSENT_ATTR`` is a stable hook for portaled overlays
    // (e.g. the Auto Tune Settings drawer) to detect clicks that
    // originate inside the banner and skip outside-interaction
    // handlers that would otherwise close them. The attribute name
    // is centralized in ``@/lib/dom-attrs`` so a search reveals every
    // contract participant.
    <div className={classes.cookie_consent} {...{ [COOKIE_CONSENT_ATTR]: "true" }}>
      <Button
        onClick={handleClose}
        title="Close cookie consent banner"
        aria-label="Close cookie consent banner"
        variant="ghost"
        size="icon"
        className="al-absolute al-top-2 al-right-2 al-h-8 al-w-8"
      >
        <CloseIcon className="al-h-4 al-w-4" />
      </Button>
      <Stack className="al-justify-between al-items-center">
        <div role="dialog" aria-labelledby="cookie-consent-title">
          <h2 id="cookie-consent-title" className="sr-only">
            Cookie Consent
          </h2>
          <p className="pt-1 mb-1">
            We use essential first-party cookies to ensure our website functions properly and
            provide you with our services.
          </p>
          <div className="flex items-center gap-1">
            <a
              href="https://docs.myaltimate.com/arch/faq/#5-what-is-your-cookie-policy"
              target="_blank"
              rel="noopener noreferrer nofollow"
              aria-label="Learn more about our cookie usage (opens in new tab)"
              className="text-blue-600 hover:text-blue-800 underline flex items-center gap-1"
            >
              Learn more about our cookie usage
            </a>
          </div>
        </div>
        <Button size="sm" type="button" onClick={acceptCookies} aria-label="Accept all cookies">
          Accept Cookies
        </Button>
      </Stack>
    </div>
  );
};

export default CookieConsentBanner;
